import { token } from '@atlaskit/tokens';
import styled, { css } from 'styled-components';
import * as grid from 'view/styles/grid';
import * as fonts from 'view/styles/fonts';
import { SearchResultKb } from 'view/common/result-kb';
import { SearchResultPortal } from '../result-portal';
import { SearchResultRequest } from '../result-request';

const buttonLineHeight = '20px';
export const SomeResultRoot = styled.div`
    /* This is used to force the container to be the same height as it's children. */
    display: table;
    /* This ensures children don't bust out past the containers width! */
    table-layout: fixed;
    max-width: ${grid.multiple(70).px};
    width: 100%;
    padding: ${token('space.100', '8px')};
    box-sizing: border-box;
`;

const resultEntry = css`
    margin: ${token('space.100', '8px')} ${token('space.0', '0px')};
`;

export const PortalResultEntry = styled(SearchResultPortal)`
    ${resultEntry};
`;

export const KbResultEntry = styled(SearchResultKb)`
    ${resultEntry};
`;

export const RequestResultEntry = styled(SearchResultRequest)`
    ${resultEntry};
`;

export const ResultTitle = styled.div`
    ${fonts.h200};
    padding-left: ${token('space.100', '8px')};
    padding-top: ${token('space.200', '16px')};
    margin-top: ${token('space.0', '0px')};
    text-transform: uppercase;
`;

export const ExpandArticleResultsButton = styled.div`
    display: flex;
    justify-content: center;
    line-height: ${buttonLineHeight};
`;

export const AllArticleResultsButton = styled.div`
    display: flex;
    justify-content: center;
    line-height: ${buttonLineHeight};
`;
